// extracted by mini-css-extract-plugin
export default {"item":"styles_item__c7FBC","questionContent":"styles_questionContent__M7ryU","question":"styles_question__HzQiz","answer":"styles_answer__a1jcm"};